import { render, staticRenderFns } from "./MySpacePriorityTasksWidget.vue?vue&type=template&id=02494070&scoped=true&"
import script from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
export * from "./MySpacePriorityTasksWidget.vue?vue&type=script&lang=js&"
import style0 from "./MySpacePriorityTasksWidget.vue?vue&type=style&index=0&id=02494070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02494070",
  null
  
)

export default component.exports